import { Injectable } from '@angular/core';
import { forkJoin, map, Observable } from 'rxjs';
import { PermissionService } from './permission.service';
import { TenantService } from './tenant.service';
import { TenantGroups } from '@app/Enums';
import { TenantGroup } from '@app/Models/tenant-group.model';

export interface TenantFormAttributes {
  tenantIndustryTypes: string[];
  tenantSizes: string[];
}

@Injectable({
  providedIn: 'root'
})
export class TenantFormOptionsService {
  constructor(
    private readonly tenantService: TenantService,
    private readonly permissionService: PermissionService,
  ) {}

  getTenantPermissionGroups(): TenantGroup[] {
    return this.permissionService.allowedTenantGroups
      .filter((group) => group !== TenantGroups.Master)
      .map((group) => ({
        description: group,
        grantedAutomaticallyWithAdmin: false,
        name: group,
        displayName: TenantGroups[group],
        permissions: 1,
      }));
  }

  getTenantAttributes(): Observable<TenantFormAttributes> {
    return forkJoin([
      this.tenantService.getTenantIndustries(),
      this.tenantService.getTenantSizes(),
    ]).pipe(
      map(([tenantIndustryTypes, tenantSizes]) => ({
        tenantIndustryTypes,
        tenantSizes,
      }))
    );
  }
}
